import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { cn } from "@/lib/utils";

// Reusable confirmation dialogs with warm Nirvana wording.
// variant: "default" | "destructive" | "restore"
export function ConfirmDialog({
  open, onOpenChange, title, description,
  confirmLabel = "Confirm", cancelLabel = "Cancel",
  variant = "default", onConfirm, testid = "confirm-dialog",
}) {
  const actionCls = variant === "destructive"
    ? "bg-destructive text-destructive-foreground hover:bg-destructive/90" : "";
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid={testid}>
        <AlertDialogHeader>
          <AlertDialogTitle className="font-heading">{title}</AlertDialogTitle>
          {description && <AlertDialogDescription>{description}</AlertDialogDescription>}
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="confirm-cancel">{cancelLabel}</AlertDialogCancel>
          <AlertDialogAction className={cn(actionCls)} onClick={onConfirm} data-testid="confirm-accept">
            {confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

export function DestructiveConfirm(props) {
  return <ConfirmDialog variant="destructive" confirmLabel={props.confirmLabel || "Delete"} testid="destructive-dialog" {...props} />;
}

export function RestoreConfirm(props) {
  return <ConfirmDialog variant="restore" confirmLabel={props.confirmLabel || "Restore"} testid="restore-dialog" {...props} />;
}
